<template>
  <div class="agent-app-filter-wrapper custom-wrapper">

    <div class="filter-wrapper">
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="代理商" prop="agentid">
          <el-select
            filterable
            default-first-option
            v-model="filterForm.agentid"
            @change="onAgentSelected" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="agent.agentname"
              :value="agent.agentid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="应用" prop="app_store_id">
          <el-select
            filterable
            default-first-option
            v-model="filterForm.app_store_id" >
            <el-option label="全部" value="" />
            <el-option
              v-for="app in appList"
              :key="app.app_store_id"
              :label="app.app_name_i18n[0].name"
              :value="app.app_store_id" />
          </el-select>
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="onFilterReset">重置</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  data () {
    return {
      filterForm: {
        agentid: '',
        app_store_id: ''
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapState('store', [
      'appList'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('agent', [
      'getAgents'
    ]),
    ...mapActions('store', [
      'getApps'
    ]),

    // 获取选择框下面的数据
    async getSelectDatas () {
      // 获取代理商数据
      try {
        this.getAgents({
          page: 1,
          pageSize: 9999
        })
      } catch (err) {
        console.log(err)
      }

      // 获取用户数据
      try {
        this.getAgents({
          page: 1,
          paegSize: 9999
        })
      } catch (err) {
        console.log(err)
      }

      try {
        this.getApps({
          page: 1,
          pageSize: 9999,
          condition: {
            app_type: 'agent'
          }
        })
      } catch (err) {
        console.log(err)
      }
    },

    // 获取用户应用
    async getAppList () {
    },

    // 代理商过滤条件选择回调，过滤用户选择列表
    onAgentSelected () {
      this.filterForm.agentid = ''
      this.getAgents({
        page: 1,
        pageSize: 9999,
        filters: {
          agentid: this.filterForm.agentid
        }
      })
    },

    // 提交表单请求
    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)
      this.$emit('filter')
    },
    // 重置表单
    onFilterReset () {
      this.$refs['filterForm'].resetFields()
      this.getSelectDatas()
    }
  },
  mounted () {
    this.getSelectDatas()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/sass/base";

.agent-app-filter-wrapper {

}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/AgentAppFilter.vue